/* SAY — UI Foundation: reveal + hero (overlap, transparente, parallax) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.say-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el){ el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el){ io.observe(el); });
  }

  function hero() {
    var heroEl = document.querySelector('[data-say-hero]');
    if (!heroEl || !document.body.classList.contains('template-index')) return;
    var copy = heroEl.querySelector('.say-hero__copy');
    var root = document.documentElement;

    function overlap() {
      var ann = document.querySelector('.wt-announcement, .wt-announcement-bar');
      var hdr = document.querySelector('header.page-header') || document.querySelector('.wt-header');
      var off = (ann ? ann.offsetHeight : 0) + (hdr ? hdr.offsetHeight : 0);
      heroEl.style.marginTop = '-' + off + 'px';
      heroEl.style.paddingTop = off + 'px';
      heroEl.style.height = (window.innerHeight + off) + 'px';
    }

    function update() {
      if (window.scrollY < (window.innerHeight - 160)) { root.classList.add('say-at-top'); }
      else { root.classList.remove('say-at-top'); }
      if (copy && !reduce && window.innerWidth >= 750) { var y = Math.min(window.scrollY, 700); copy.style.transform = 'translateY(' + (y * 0.05) + 'px)'; }
      else if (copy) { copy.style.transform = ''; }
    }

    overlap(); update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { overlap(); update(); }, { passive: true });
    window.addEventListener('load', overlap);
  }

  function init(){ reveal(); hero(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
